import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import MasterLab from "./pages/MasterLab";
import MasterRadiology from "./pages/MasterRadiology";
import MasterJasa from "./pages/MasterJasa";
import MasterObat from "./pages/MasterObat";
import MasterFasilitas from "./pages/MasterFasilitas";
import UnitCostPage from "./pages/UnitCostPage";
import MCUCalculator from "./pages/MCUCalculator";
import Packages from "./pages/Packages";
import Settings from "./pages/Settings";
import Assets from "./pages/Assets";
import AuditLog from "./pages/AuditLog";
import AssetLabelsPrint from "./pages/AssetLabelsPrint";
import AssetPublicDetail from "./pages/AssetPublicDetail";

function Protected({ children }) {
    const { user, loading } = useAuth();
    const location = useLocation();
    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center text-[#4A5E57]">
                Memuat...
            </div>
        );
    }
    if (!user)
        return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
    return children;
}

function App() {
    return (
        <div className="App">
            <AuthProvider>
                <BrowserRouter>
                    <Toaster position="top-right" richColors />
                    <Routes>
                        <Route path="/login" element={<Login />} />
                        <Route
                            path="/aset/:id"
                            element={
                                <Protected>
                                    <AssetPublicDetail />
                                </Protected>
                            }
                        />
                        <Route
                            path="/assets/print"
                            element={
                                <Protected>
                                    <AssetLabelsPrint />
                                </Protected>
                            }
                        />
                        <Route
                            path="/"
                            element={
                                <Protected>
                                    <Layout />
                                </Protected>
                            }
                        >
                            <Route index element={<Dashboard />} />
                            <Route path="master/lab" element={<MasterLab />} />
                            <Route path="master/radiology" element={<MasterRadiology />} />
                            <Route path="master/jasa" element={<MasterJasa />} />
                            <Route path="master/obat" element={<MasterObat />} />
                            <Route path="master/fasilitas" element={<MasterFasilitas />} />
                            <Route path="unit-cost/:kind" element={<UnitCostPage />} />
                            <Route path="mcu" element={<MCUCalculator />} />
                            <Route path="mcu/:id" element={<MCUCalculator />} />
                            <Route path="packages" element={<Packages />} />
                            <Route path="assets" element={<Assets />} />
                            <Route path="audit-log" element={<AuditLog />} />
                            <Route path="settings" element={<Settings />} />
                        </Route>
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                </BrowserRouter>
            </AuthProvider>
        </div>
    );
}

export default App;
